/*
Item: ExtraContainer is a Drag'n'Drop Component for adding Cards between existing Rows or Columns
in Statistics.jsx
Name: ExtraContainer
Format: Code/Frontend component
*/

import React, { Component } from 'react';
import { DropTarget } from 'react-dnd';

class ExtraContainer extends Component {
  constructor(props) {
    super(props);
    this.pushCard = this.props.pushCard;
  }

  render() {
    const {
      canDrop, isOver, connectDropTarget, style
    } = this.props;
    const isActive = canDrop && isOver;
    const isDuplicate = !canDrop && isOver;

    const backgroundColor = isActive ? 'lightgreen' : isDuplicate ? '#FFB3B3' : 'transparent';

    return connectDropTarget(
      <div
        style={{
          ...style,
          backgroundColor,
          position: 'relative',
          zIndex: '10',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <i
          style={{ color: isActive ? 'black' : 'transparent' }}
          className="pi pi-plus"
        />
      </div>
    );
  }
}

const cardTarget = {
  drop(props, monitor, component) {
    const { id } = props;
    const { containerName } = props;
    const { nextCol } = props;
    const sourceObj = monitor.getItem();

    if (id !== sourceObj.listId) {
      component.pushCard(nextCol, sourceObj.card, containerName).then(() => {
      });
    } else {
      const { makeNestedList } = props;
      const { list } = props;
      makeNestedList(containerName, list);
    }
    return {
      listId: id,
    };
  },
  canDrop(props, monitor) {
    const { nextCol } = props;
    const sourceObj = monitor.getItem();
    const { checkIdDigitCount } = props;
    const { list } = props;
    console.log("CANDROP", list, sourceObj)

    // Die Contaier für Zeilen und Spalten haben unterschiedliche Id-Bereiche (Zeilen 100+; Spalten 1000+) 
    // Folgende Fälle müssen nur geprüft werden, wenn die Id des Containers in dem entsprechenden Bereich liegt (checkDigitCount = Zeichenlänge des Id-Bereichs)
    // Diese Lösung könnte sicherlich Verbessert werden!
    if (sourceObj.listId.toString().length === checkIdDigitCount) {
      // Das Verschieben des letzten Merkmals in die nachfolgende Spalte/Zeile macht keinen Sinn,, da sich die Tabellenstruktur dadurch nicht ändern würde.
      if (nextCol === sourceObj.containerName + 1 && sourceObj.index === 0) {
        return false;
      }
      // Durch die aktuelle Umsetzung, dürfen die Merkmale nicht nach hinten (z.B. von Zeilendefinition 2 vor Zeilendefinition 1) verschoben werden.
      // Durch das Verschieben wird eine neue Zeile oder Spalte angelegt und dadurch entsteht ein Fehler beim löschen des ursprünglichen Eintrags.
      if (nextCol <= sourceObj.containerName) {
        return false;
      }
    }
    return true;
  },
};

export default DropTarget('CARD', cardTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop(),
}))(ExtraContainer);
